import { Injectable, ViewChild, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CanDeactivate } from '@angular/router';
import { ComponentCanDeactivate } from './models';
import { ModalPromptComponent } from '../helper-components/modal-prompt.component';
import { ModalPromptService, PromptOptions } from '../helper-components/modal-prompt.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}
@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {

  options: PromptOptions = { 
    header: 'Cancel changes?', 
    body: 'You have unsaved changes. Press Cancel to stay in this page and save these changes, or OK to discard these changes.' 
  };

  constructor(private _prompt: ModalPromptService) {

  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    if (component.canDeactivate()) {
      return true;
    }
    
    let r = this._prompt.openModal(null, true, this.options);
    return r.asObservable();

  }
  
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/core/pending-changes.guard.ts